/** Служебные Discord-каналы и роли (синхронно с server/utils/discordOpsSettings.js) */

export const DISCORD_OPS_SETTING_KEY = 'discord_ops';

export const DEFAULT_DISCORD_OPS = {
  shifts_channel_id: '',
  afk_notification_channel_id: '',
  logs_channel_id: '',
  activity_logs_channel_id: '',
  no_moderators_channel_id: '',
  notify_channel_id: '',
  staff_list_channel_id: '',
  players_notify_channel_id: '',
  stats_notification_channel_id: '',
  stats_notification_role_id: '',
  manager_role_id: '',
  junior_role_id: '',
};

const SNOWFLAKE_RE = /^\d{17,20}$/;

function parseSnowflake(value) {
  const s = String(value == null ? '' : value).trim();
  if (!s) return '';
  return SNOWFLAKE_RE.test(s) ? s : s;
}

export function normalizeDiscordOps(raw) {
  const source = raw && typeof raw === 'object' ? raw : {};
  const out = { ...DEFAULT_DISCORD_OPS };
  Object.keys(DEFAULT_DISCORD_OPS).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      out[key] = parseSnowflake(source[key]);
    }
  });
  return out;
}

/** Секции вкладки «Каналы» */
export const DISCORD_OPS_SECTIONS = [
  {
    id: 'main',
    title: 'Основные',
    fields: [
      { key: 'logs_channel_id', label: 'Логи', hint: 'Основной канал логов бота' },
      {
        key: 'activity_logs_channel_id',
        label: 'Логи активности',
        hint: 'Действия на сайте (создал/изменил модератора и т.д.). Бот сайта должен видеть канал и иметь право писать + embeds',
      },
      { key: 'notify_channel_id', label: 'Уведомления (пинг)', hint: 'Общие оповещения с пингом ролей' },
    ],
  },
  {
    id: 'shifts',
    title: 'Смены',
    fields: [
      { key: 'shifts_channel_id', label: 'Таблица смен', hint: 'Канал со списком на смене' },
      { key: 'afk_notification_channel_id', label: 'AFK', hint: 'Оповещения об AFK' },
      { key: 'no_moderators_channel_id', label: 'Нет модераторов', hint: 'Когда на смене никого нет' },
    ],
  },
  {
    id: 'players',
    title: 'Уведомления игроков',
    fields: [
      {
        key: 'players_notify_channel_id',
        label: 'Канал рассылки',
        hint: 'Куда self-бот шлёт уведомления игрокам',
      },
    ],
  },
  {
    id: 'stats',
    title: 'Статистика Managers',
    fields: [
      {
        key: 'stats_notification_channel_id',
        label: 'Канал уведомлений',
        hint: 'Куда отправляется уведомление об обновлённой статистике',
      },
      {
        key: 'stats_notification_role_id',
        label: 'Тег (роль)',
        hint: 'Роль, которую пингует кнопка уведомлений в статистике',
        kind: 'role',
      },
    ],
  },
  {
    id: 'roles',
    title: 'Роли',
    fields: [
      { key: 'manager_role_id', label: 'Manager', hint: 'ID роли для пинга менеджеров', kind: 'role' },
      { key: 'junior_role_id', label: 'Junior', hint: 'ID роли для пинга Junior', kind: 'role' },
    ],
  },
];
